import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UtilityService } from '@common/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'sbf-rally-game-share-modal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './rally-game-share-modal.component.html',
    styleUrls: ['rally-game-share-modal.component.scss'],
})
export class RallyGameShareModalComponent implements OnInit {
    canShare = false;

    constructor(
        public activeModal: NgbActiveModal,
        private utilityService: UtilityService
    ) {}
    ngOnInit() {
        if (!!this.utilityService.window?.navigator?.share) {
            this.canShare = true;
        }
    }
    copyToClipboard() {
        this.utilityService.copyToClipboard(`Check out Tredder Rally: https://tredder.com/rally`);
    }
    share() {
        this.utilityService.window.navigator
            .share({
                title: 'Tredder Rally Challenge',
                text: `Check out Tredder Rally: https://tredder.com/rally`,
            })
            .then(() => {})
            .catch((error) => console.log('Error sharing', error));
    }
}
